module.exports = __webpack_public_path__ + "img/Pack cardio.b6416522.jpg";